import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IBoDoiCongAnActionTypes } from "../../action-types/bodoi-congan/IBoDoiCongAnActionTypes";
import { IBoDoiCongAnReducer } from "../../page-state-model/bodoi-congan/IBoDoiCongAnReducer";
const iniState: IBoDoiCongAnReducer = {
    status: ePageBaseStatus.is_not_initialization,
    boDoiCongAns: []
}
export const boDoiCongAnReducer = (state: IBoDoiCongAnReducer = iniState, action: IBoDoiCongAnActionTypes): IBoDoiCongAnReducer => {
    switch (action.type) {
        case "BODOI_CONGAN_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "BODOI_CONGAN_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                boDoiCongAns: action.payload
            }
        case "BODOI_CONGAN_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                boDoiCongAns: []
            }
        case "BODOI_CONGAN_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "BODOI_CONGAN_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "BODOI_CONGAN_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "BODOI_CONGAN_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "BODOI_CONGAN_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "BODOI_CONGAN_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "BODOI_CONGAN_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "BODOI_CONGAN_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}